import { render } from "./ShopifyInstall.vue?vue&type=template&id=5dd8b8ee&scoped=true&ts=true"
import script from "./ShopifyInstall.vue?vue&type=script&lang=ts"
export * from "./ShopifyInstall.vue?vue&type=script&lang=ts"

import "./ShopifyInstall.vue?vue&type=style&index=0&id=5dd8b8ee&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5dd8b8ee"]])

export default __exports__